export default "__VITE_ASSET__ClyiSZ3u__"